import './App.css';
import './Feedback.css';
import { AuthProvider } from './context/AuthContext';
import { TimeEntryPage } from './pages/TimeEntryPage';

/**
 * Port of `src/App.js`.
 *
 * App.js did two jobs: the auth bootstrap and the page chrome. The bootstrap moved to
 * `context/AuthContext`; this file is now just the provider plus the page, so that
 * NavBar and MainMenu read the same values from context rather than through props.
 */
export default function App(): JSX.Element {
  return (
    <AuthProvider>
      <TimeEntryPage />
    </AuthProvider>
  );
}
